export class Policy {
  /**
   * Create new policy and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)

    // Map business policies to Policy
    if (typeof this.businessPolicies !== 'undefined') {
      this.policies = this.businessPolicies.map(policy => new BusinessPolicy(policy))
    }
  }

  /**
   * @return {null}
   */
  get title () {
    return null
  }

  /**
   * @return {null}
   */
  get subtitle () {
    return null
  }

  /**
   * @return {null}
   */
  get id () {
    return null
  }

  businessPolicy (context) {
    return (this.policies || []).find(item => context.business.id === item.id) || null
  }

  hasAnyBusinessRole (context) {
    if (this.roles.length > 0 || typeof this.partnerPolicy !== 'undefined') {
      return true
    }

    const business = this.businessPolicy(context)

    return business !== null ? business.roles.length > 0 : false
  }

  merchantPolicy (context) {
    const business = this.businessPolicy(context)

    return business !== null && business.policies && business.policies.some(item => context.merchant.id === item.id) ? business.policies.find(item => context.merchant.id === item.id) : null
  }

  hasAnyMerchantRole (context) {
    if (this.roles.length > 0 || this.hasAnyBusinessRole(context)) {
      return true
    }

    const merchant = this.merchantPolicy(context)

    return merchant !== null ? merchant.roles.length > 0 : false
  }
}

export class BusinessPolicy extends Policy {
  /**
   * Create new business policy and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    super(obj)

    // Map merchant policies to Policy
    if (typeof this.merchantPolicies !== 'undefined') {
      this.policies = this.merchantPolicies.map(policy => new MerchantPolicy({ businessId: this.id, ...policy }))
    }
  }

  /**
   * @return {string}
   */
  get title () {
    return this.businessName
  }

  /**
   * @return {string}
   */
  get id () {
    return this.businessId
  }
}

export class MerchantPolicy extends Policy {
  /**
   * Create new merchant policy and set properties based on the given object.
   */

  /**
   * @return {string}
   */
  get title () {
    return this.merchantName
  }

  /**
   * @return {string}
   */
  get id () {
    return this.merchantId
  }
}

export class ConfigurationPolicy extends Policy {
  /**
   * Create new Configuration policy and set properties based on the given object.
   */

  /**
   * @return {string}
   */
  get title () {
    return this.tradeName
  }

  /**
   * @return {string}
   */
  get subtitle () {
    return this.description
  }

  /**
   * @return {string}
   */
  get id () {
    return this.configurationId
  }
}
